import React, { useEffect } from "react";
import {
  Link,
  useParams,
  useSearchParams,
  useNavigate,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Row,
  Col,
  ListGroup,
  Image,
  Form,
  Button,
  Card,
} from "react-bootstrap";
import Message from "../common/Message";
import Meta from "../common/Meta";
import { currencyFormat } from "../../utils/currencyFormat";
import { addToBooking, removeFromBooking } from "../../actions/bookingActions";

const BookingScreen = () => {
  const { id: productId } = useParams();

  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams();
  const qty = Number(searchParams.get("qty"));

  const dispatch = useDispatch();

  const booking = useSelector((state) => state.booking);
  const { bookingItems } = booking;

  useEffect(() => {
    if (productId) {
      dispatch(addToBooking(productId, qty));
    }
  }, [dispatch, productId, qty]);

  const removeFromBookingHandler = (id) => {
    dispatch(removeFromBooking(id));
  };

  const checkoutHandler = () => {
    navigate(`/login?redirect=delivery`);
  };

  return (
    <Row>
      <Meta title="Booking" />
      <Col md={8}>
        <h1>Booking Items</h1>
        {bookingItems.length === 0 ? (
          <>
            <Link to="/" className="btn my-2 bg-primary btn-hover">
              Go Back
            </Link>
            <Message>Your book is empty </Message>
          </>
        ) : (
          <ListGroup variant="flush">
            {bookingItems.map((item) => (
              <ListGroup.Item key={item.product} variant="light">
                <Row>
                  <Col md={2}>
                    <Image src={item.image} alt={item.name} fluid rounded />
                  </Col>
                  <Col md={3}>
                    <Link to={`/item/${item.product}`} className="link">
                      {item.name}
                    </Link>
                  </Col>
                  <Col md={2}>
                    {item.isDozen ? "Price per dozen: " : "Price: "}

                    {currencyFormat(item.price)}
                  </Col>
                  <Col md={2}>
                    <Form.Control
                      as="select"
                      value={item.qty}
                      onChange={(e) =>
                        dispatch(
                          addToBooking(item.product, Number(e.target.value))
                        )
                      }
                    >
                      {[...Array(item.countInStock).keys()].map((x) => (
                        <option key={x + 1} value={x + 1}>
                          {x + 1}
                        </option>
                      ))}
                    </Form.Control>
                  </Col>
                  <Col md={2}>
                    <Button
                      className="bg-primary btn-hover"
                      type="button"
                      variant="light"
                      onClick={() => removeFromBookingHandler(item.product)}
                    >
                      <i className="fas fa-trash "></i>
                    </Button>
                  </Col>
                </Row>
              </ListGroup.Item>
            ))}
          </ListGroup>
        )}
      </Col>
      <Col md={4}>
        <Card>
          <ListGroup variant="flush">
            <ListGroup.Item variant="light">
              <h2>Booking Summary</h2>
            </ListGroup.Item>
            <ListGroup.Item variant="light">
              <h4>
                Subtotal (
                {bookingItems.reduce((acc, item) => acc + item.qty, 0)}) items
              </h4>
              {currencyFormat(
                bookingItems
                  .reduce((acc, item) => acc + item.qty * item.price, 0)
                  .toFixed(2)
              )}
            </ListGroup.Item>
            <ListGroup.Item variant="light">
              <div className="d-flex justify-content-center">
                {" "}
                <Button
                  type="button"
                  className="btn-block"
                  disabled={bookingItems.length === 0}
                  onClick={checkoutHandler}
                >
                  Proceed To Checkout
                </Button>
              </div>
            </ListGroup.Item>
          </ListGroup>
        </Card>
      </Col>
    </Row>
  );
};

export default BookingScreen;
